export function Newsletter() {
    return (
        <section className="py-24 text-center max-w-2xl mx-auto px-6">
            <h2 className="font-serif text-4xl mb-6 italic">Join the Circle</h2>
            <p className="text-stone-500 mb-10 font-light">
                Receive exclusive access to new collections, seasonal scents, and artisanal journals.
            </p>
            <form className="flex flex-col md:flex-row gap-4" onSubmit={(e) => e.preventDefault()}>
                <input
                    type="email"
                    placeholder="Your email address"
                    className="flex-1 bg-transparent border-b border-stone-300 py-3 px-1 focus:outline-none focus:border-stone-900 transition-colors font-light"
                />
                <button className="bg-stone-900 text-white px-10 py-3 text-xs uppercase tracking-widest hover:bg-stone-800 transition-colors">
                    Subscribe
                </button>
            </form>
        </section>
    );
}
